import styled from "styled-components";
import { tokens } from "@manifesthhqinc/ui-library";

export const ProgressBarContainer = styled.div`
  position: absolute;
  top: 65px;
  left: -5px;
  right: -5px;
  width: calc(100% + 10px);
  background: ${tokens.color.neutral[200]};
  z-index: 1000;
`;

export const ProgressBarDiv = styled.div<{ $progress: number }>`
  width: 100%;
  background: ${tokens.color.neutral[200]};
  height: 8px;
  position: relative;
  border-radius: 4px;

  &:after {
    position: absolute;
    border-radius: 10px;
    left: 0;
    top: 0;
    bottom: 0;
    width: ${(props) => props.$progress}%;
    background: ${tokens.color.brand[400]};
    content: "";
    transition: width 0.45s ease-in-out;
  }
`;
